import { render, staticRenderFns } from "./BusinessPartnerDetail.vue?vue&type=template&id=50e9091a&scoped=true"
import script from "./BusinessPartnerDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessPartnerDetail.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPartnerDetail.vue?vue&type=style&index=0&id=50e9091a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9091a",
  null
  
)

export default component.exports